import request from '@/http/request'
export const getPermissionList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/permission/list`, params)
}
export const getRoleSearch = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/role/search`, { params })
}
export const saveRole = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/role/add`, params, { hiddenError: true })
}
export const updateRole = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/role/update`, params, { hiddenError: true })
}
export const getRoleDetail = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/role/detail`, { params })
}

export const getRoleList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/role/list`, { params })
}

export const getRoleDetailList = params => {
  return request.get(
    `${process.env.REACT_APP_API_URL}/cro/v1/role/detailList
  `,
    { params }
  )
}
